import * as React from 'react';
import TableModal from '../../../../../../atomic/organisms/TableModal';
import {
  EmployeeScopeFilter,
  useDashboardAbsentTodayQuery,
} from '../../../../__generated__/graphql';
import ServerError from '../../../../../../components/ServerError';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';
import { mapAbsenceForModal } from './mapping';
import { toISODateOnly } from '../../../../../../utils/dateUtils';

type Props = {
  onClose: () => void;
  filterBy: EmployeeScopeFilter;
};

const i18Path = 'dashboard.absentTodayWidget';

const AbsentTodayModal: React.FC<Props> = ({ onClose, filterBy }) => {
  const t = useNamespacedTranslation(i18Path);
  const tModal = useNamespacedTranslation(`${i18Path}.modal`);

  const { data, loading, error } = useDashboardAbsentTodayQuery({
    variables: {
      from: toISODateOnly(new Date()),
      to: toISODateOnly(new Date()),
      filterBy: filterBy,
      limit: null,
    },
  });

  const headers = [
    {
      key: 'employee',
      title: tModal('employee'),
    },
    {
      key: 'department',
      title: tModal('department'),
    },
    {
      key: 'location',
      title: tModal('location'),
    },
    {
      key: 'additionalInfo',
      title: tModal('backIn'),
    },
  ];

  if (error) {
    return <ServerError />;
  }

  const absences =
    data?.allAbsences
      .filter((a) => a.employee !== null)
      .map((ab) => mapAbsenceForModal(ab, t)) ?? [];

  return (
    <TableModal
      title={t('title')}
      onClose={onClose}
      headers={headers}
      data={absences}
      loading={loading}
    />
  );
};

export default AbsentTodayModal;
